@if (status() === 'playing') {
  <button
    appButton
    name="pause"
    location="article-speech"
    [hasIcon]="true"
    shape="round"
    weight="bold"
    (click)="pause()"
  >
    <app-svg src="/assets/icons/pause.svg"></app-svg>
    <span>Pause</span>
  </button>
} @else {
  <button appButton name="play" location="article-speech" [hasIcon]="true" shape="round" weight="bold" (click)="play()">
    <app-svg src="/assets/icons/play-outline.svg"></app-svg>
    <span>Listen</span>
  </button>
}
